import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { mostrarFaixaDoAmbiente } from '../../compartilhado/faixa-ambiente';
import './estilo.css';

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/* "DEV" no canto quando o servidor é o de teste. Ver o arquivo. */
mostrarFaixaDoAmbiente();
